'use client'

import { useCallback, useState } from 'react'
import useCmsSellers from '../../../core/hook/useCmsSellers'
import useCurrentLocale from '../../../core/hook/useCurrentLocale'
import { CmsSellerFilters } from '../../../domain/seller'
import { getIsChinaStore, getIsKoreaLocale} from '../../utils/locale.utils'
import BaiduSellersPage from './BaiduMap/BaiduSellersPage'
import { GoogleMapSellersPageLoadApi } from './GoogleMap/GoogleMapSellersPageLoadApi'
import { NaverMapSellersPageLoadApi } from './Naver/NaverSellersPageLoadApi'

const SellersMap = () => {
  const [filters, setFilters] = useState<CmsSellerFilters>({})
  const locale = useCurrentLocale()

  const sellers = useCmsSellers(filters)
  const onSubmitFilterForm = useCallback((value: CmsSellerFilters) => setFilters(value), [])

  const isUserInChina = getIsChinaStore(locale)
  const isUserInKorea = getIsKoreaLocale(locale)

  if (isUserInChina) {
    return (
      <BaiduSellersPage
        sellers={sellers}
        onSubmitFilterForm={onSubmitFilterForm}
        filters={filters}
      />
    )
  }

  if(isUserInKorea){
    return (
      <NaverMapSellersPageLoadApi
        sellers={sellers}
        onSubmitFilterForm={onSubmitFilterForm}
        filters={filters}
      />
    )
  }

  return (
    <GoogleMapSellersPageLoadApi
      sellers={sellers}
      onSubmitFilterForm={onSubmitFilterForm}
      filters={filters}
    />
  )
}

export default SellersMap
